import {Actions} from '@redstack/shared'
import {createFileRoute} from '@tanstack/react-router'
import {StaffPage} from '@/features/admin/StaffPage'
import {useRequirePermission} from '@/hooks/useRequirePermission'

function StaffGuard() {
	if (!useRequirePermission(Actions.ORGS_MANAGE)) return null
	return <StaffPage />
}

export const Route = createFileRoute('/admin/staff')({
	component: StaffGuard,
})
